import { filter } from 'rxjs';

export function isNonNull<T>(value: T): value is NonNullable<T> {
    return value != null;
}
export function isDefined<T>(value: T): value is T extends undefined ? never : T {
    return value != undefined;
}

export const rxjsSkipNullish = filter(isNonNull);
export const skipUndefined = filter(isDefined);
